import { render, staticRenderFns } from "./OweMapBorderCompo.vue?vue&type=template&id=5cc4f802&"
import script from "./OweMapBorderCompo.vue?vue&type=script&lang=js&"
export * from "./OweMapBorderCompo.vue?vue&type=script&lang=js&"
import style0 from "./OweMapBorderCompo.vue?vue&type=style&index=0&id=5cc4f802&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports